/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCustomerBankingAccountV1Dto } from '../models/CreateCustomerBankingAccountV1Dto';
import type { CustomerBankingAccountV1Dto } from '../models/CustomerBankingAccountV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchCustomerBankingAccountV1Dto } from '../models/PatchCustomerBankingAccountV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomerBankingAccountsService {
  /**
   * @param requestBody
   * @returns CustomerBankingAccountV1Dto create entity
   * @throws ApiError
   */
  public static customerBankingAccountControllerV1CreateV1(
    requestBody: CreateCustomerBankingAccountV1Dto,
  ): CancelablePromise<CustomerBankingAccountV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/customer-banking-accounts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns CustomerBankingAccountV1Dto a entity list
   * @throws ApiError
   */
  public static customerBankingAccountControllerV1FindAllV1(): CancelablePromise<
    Array<CustomerBankingAccountV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/customer-banking-accounts',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static customerBankingAccountControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/customer-banking-accounts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid customerBankingAccountId
   * @returns CustomerBankingAccountV1Dto the entity
   * @throws ApiError
   */
  public static customerBankingAccountControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<CustomerBankingAccountV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/customer-banking-accounts/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid customerBankingAccountId
   * @param requestBody
   * @returns CustomerBankingAccountV1Dto the update entity
   * @throws ApiError
   */
  public static customerBankingAccountControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchCustomerBankingAccountV1Dto,
  ): CancelablePromise<CustomerBankingAccountV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/customer-banking-accounts/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid customerBankingAccountId
   * @returns CustomerBankingAccountV1Dto the entity
   * @throws ApiError
   */
  public static customerBankingAccountControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<CustomerBankingAccountV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/customer-banking-accounts/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
